import React from 'react'
import { Box } from '@maas-components/core'
import PropTypes from 'prop-types'

const Center = ({ children }) => {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      height="calc(100vh - 80px)"
      justifyContent="center"
      textAlign="center"
    >
      {children}
    </Box>
  )
}

Center.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Center
